import { render } from "./EditorHtml.vue?vue&type=template&id=01cf2390&ts=true"
import script from "./EditorHtml.vue?vue&type=script&lang=ts"
export * from "./EditorHtml.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__